// is used in csl_devops' i18n script
// i18n script reads json from `LANGUAGES_REGISTRY` to `;` char
const LANGUAGES_REGISTRY = {
  "cs": "Čeština",
  "da": "Dansk",
  "de": "Deutsch",
  "el": "Ελληνικά",
  "en": "English",
  "es": "Español",
  "et": "Eesti",
  "fi": "Suomi",
  "fr": "Français",
  "ga": "Gaeilge",
  "hr": "Hrvatski",
  "hu": "Magyar",
  "is": "Íslenska",
  "it": "Italiano",
  "lb": "Lëtzebuergesch",
  "lt": "Lietuvių",
  "lv": "Latviešu",
  "nl": "Nederlands",
  "no": "Norsk",
  "pl": "Polski",
  "pt": "Português",
  "sk": "Slovenčina",
  "sl": "Slovenščina",
  "sv": "Svenska"
};


// sorted map
const LNG_MAP = Object.keys(LANGUAGES_REGISTRY).sort().reduce(
  (obj, key) => {
    obj[key] = LANGUAGES_REGISTRY[key];
    return obj;
  },
  {}
);

export default LNG_MAP;
